function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var CaretRight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "CaretRightIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "m16.5 11.961-7.304 7.25a.998.998 0 0 1-1.405 0 .983.983 0 0 1-.291-.697V5.486a.99.99 0 0 1 .993-.986c.262 0 .513.102.699.285l7.308 7.176z"
    })
  }));
});
CaretRight.displayName = 'CaretRightIcon';
export default CaretRight;